import { Group } from "@planzone/dto";

function isNameValid(name: string) {
  return name.length > 0;
}

function isGroupValid(group: Group): boolean {
  return isNameValid(group.name);
}

export { isGroupValid };
